import { collection, doc, getDoc, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";

// "Can you make it?" answers. The backend asks every RSVP the day before and
// records each answer at eventAttendance/{eventId}_{uid} (server-written; the
// rules let admin operators and the event's hosts read by eventId). Nothing
// here writes: an answer arrives by text, a tap in the app or on the web, or
// through Gist AI, and the server records it.
//
// Two companions, also server-written: eventAttendanceSummaries/{eventId} (the
// host tally and, after the event, how many of each answer showed up) and
// memberReliability/{uid} (a member's running totals; admin operators only).
const COLLECTION = "eventAttendance";
const SUMMARIES = "eventAttendanceSummaries";
const RELIABILITY = "memberReliability";

class EventAttendanceApi {
  static collectionName = COLLECTION;

  /**
   * Live map of userId -> { id, eventId, userId, status, answer, reply,
   * askedAt, answeredAt, ... } for one event. Returns the unsubscribe.
   */
  static subscribeByEvent(eventId, onData, onError) {
    const q = query(collection(db, COLLECTION), where("eventId", "==", eventId));
    return onSnapshot(
      q,
      (snapshot) => {
        const byUser = {};
        snapshot.docs.forEach((d) => {
          const data = d.data();
          if (data?.userId) byUser[data.userId] = { id: d.id, ...data };
        });
        onData(byUser);
      },
      onError
    );
  }

  /** Live eventAttendanceSummaries/{eventId} data, or null while there is none. */
  static subscribeSummary(eventId, onData, onError) {
    return onSnapshot(
      doc(db, SUMMARIES, eventId),
      (snapshot) => onData(snapshot.exists() ? snapshot.data() : null),
      onError
    );
  }

  /**
   * A member's show-up totals, or null. Admin operators only: for anyone else
   * the rules refuse the read, which is reported as null, not thrown.
   */
  static async getMemberReliability(userId) {
    if (!userId) return null;
    try {
      const snapshot = await getDoc(doc(db, RELIABILITY, userId));
      return snapshot.exists() ? snapshot.data() : null;
    } catch {
      return null;
    }
  }
}

export default EventAttendanceApi;
